import React, { useEffect, useState } from "react";

import { decode } from "html-entities";
import AOS from "aos";
import "aos/dist/aos.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  EmailValidation,
  NonEmptyValidation,
  PhoneNumberValidation,
  StringValidation,
} from "../../Store/validate";
import {
  GetSpecificProperty,
  GetUser,
  UserServiceRequest,
  UseraboutContent,
} from "../../Api/Api";
import CustomModal from "../CustomModal";
import ServicesAllpages from "../ServicesAllpages";

export default function BSHouseSpecific() {
  useEffect(() => {
    AOS.init();
  }, []);

  const state = useSelector((state) => state);

  const [bsHouseSpec, setBsHouseSpec] = useState({});

  const [bsHouseSpecValidation, setBsHouseSpecValidation] = useState({});

  const setBsHouseSpecValue = (key, value) => {
    setBsHouseSpec({ ...bsHouseSpec, [key]: value });
    if (bsHouseSpecValidation[key]) delete bsHouseSpecValidation[key];
  };

  const setBsHouseSpecValidationValue = (key, value) => {
    setBsHouseSpecValidation({ ...bsHouseSpecValidation, [key]: value });
  };

  //error
  const showToastErrorMsg = (errMsg) => {
    toast.error(errMsg, {
      position: toast.POSITION.TOP_RIGHT,
      className: "toast-message",
      autoClose: 5000,
    });
  };

  //success
  const showToastSuccessMsg = (successMsg) => {
    toast.success(successMsg, {
      position: toast.POSITION.TOP_RIGHT,
      className: "toast-message",
      autoClose: 3000,
    });
  };

  const [userBsHouseSpecProfile, setUserBsHouseSpecProfile] = useState([]);
  useEffect(() => {
    if (state?.auth?.isLoggedIn === true) {
      getBsHouseSpecProfile();
    }
    getBsHouseSpecfilter();
  }, []);
  const getBsHouseSpecProfile = async () => {
    const id = state?.auth?.auth?._id;
    const token = state.auth.auth.token;
    const response = await GetUser(token, id);
    if (response.statusCode === 200) {
      setUserBsHouseSpecProfile(response.data);
    } else {
      //console.log("error while getting user profile info");
    }
  };

  const naviGation = useNavigate();

  const handleSubmit = async (e) => {
    let local = localStorage?.getItem("category")?.split("&");
    let local1 = local[0]?.split("/");
    e.preventDefault();

    let validate = {};
    validate.name = StringValidation(bsHouseSpec?.name);
    validate.emailId = EmailValidation(bsHouseSpec?.emailId);
    validate.subject = NonEmptyValidation(bsHouseSpec?.subject);
    validate.question = NonEmptyValidation(bsHouseSpec?.question);
    validate.mobileNumber = PhoneNumberValidation(bsHouseSpec?.mobileNumber);
    validate.servicesType = NonEmptyValidation(bsHouseSpec?.servicesType);

    setBsHouseSpecValidation(validate);
    if (Object.values(validate).every((v) => v.status === true)) {
      const Payload = {
        name: bsHouseSpec.name,
        emailId: bsHouseSpec.emailId,
        subject: bsHouseSpec.subject,
        question: bsHouseSpec.question,
        mobileNumber: bsHouseSpec.mobileNumber,
        userId: state?.auth?.auth?._id,
        servicesType: bsHouseSpec.servicesType,
      };

      const response = await UseraboutContent(Payload);
      if (response && response.statusCode === 200) {
        
        showToastSuccessMsg(response.message);
        
        
        window.location.reload();
        setBsHouseSpec({});

        localStorage?.removeItem("category");
        localStorage?.removeItem("subcategory");
        localStorage?.removeItem("title");
      } else {
        showToastErrorMsg(
          response.message || response.error.response.data.message
        );
      }
    } else {
      //console.log("Error while submit a service request");
    }
    // }
  };
  const handleSubmitBsHouseSpec = async (e) => {
    e.preventDefault();
    let local = localStorage?.getItem("category")?.split("&");
    let local1 = local[0]?.split("/");
    if (state?.auth?.isLoggedIn) {
      const Payload = {
        name: userBsHouseSpecProfile.name,
        email: userBsHouseSpecProfile.email,
        subject: " ",
        question: " ",
        mobileNumber: userBsHouseSpecProfile.phoneNumber,
        userId: state?.auth?.auth?._id,
        property_id: id,
        type: "property",
       
      };
      const token = state?.auth?.auth?.token;
      const response = await UserServiceRequest(Payload);
      if (response && response.statusCode === 200) {
        setBsHouseSpec({});
        showToastSuccessMsg(response.message);
      } else {
        showToastErrorMsg(
          response.message || response.error.response.data.message
        );
      }
    }
  };
  const [bsHouseSpecList, setBsHouseSpecList] = useState({});
 
  const [metatag, setMetatag] = useState([]);

  const { id } = useParams();
  const getBsHouseSpecfilter = async () => {
    
    const response = await GetSpecificProperty(id);
    if (response && response.statusCode === 200) {
      setBsHouseSpecList(response.data);
    } else {
      setBsHouseSpecList({});
      showToastErrorMsg(response.message);
    }
  };

  const [bsHouseSpec1, setBsHouseSpec1] = useState({});
  const [form, setForm] = useState(false);

  const [bsHouseSpecValidation1, setBsHouseSpecValidation1] = useState({});

  const setBsHouseSpecValue1 = (key, value) => {
    setBsHouseSpec1({ ...bsHouseSpec1, [key]: value });
    if (bsHouseSpecValidation1[key]) delete bsHouseSpecValidation1[key];
  };

  const setBsHouseSpecValidationValue1 = (key, value) => {
    setBsHouseSpecValidation1({ ...bsHouseSpecValidation1, [key]: value });
  };

  let cat = localStorage?.getItem("category")?.split("?");

  const handleSubmitServiceform = async (e) => {
    e.preventDefault();
    const Payload = {
      name: bsHouseSpec1.name,
      email: bsHouseSpec1.email,
      subject: bsHouseSpec1.subject,
      question: bsHouseSpec1.question,
      mobileNumber: bsHouseSpec1.mobileNumber,
      type: "property",
      property_id: id,
    };
   
    const response = await UserServiceRequest(Payload);
    if (response && response.statusCode === 200) {
      showToastSuccessMsg(response.message);
      setBsHouseSpec1({});
      setForm(false);
    } else {
      showToastErrorMsg(
        response.message || response.error.response.data.message
      );
    }
  };

  return (
    <div className="overflow-pages">
      <ToastContainer />
      <div className="about-banner2 py-5">
        <div className="container">
          <section className="property">
            <div className="container">
              <div className="projectrow">
                <div className="row">
                  <div className="col-lg-11 mx-auto ms-auto">
                    <div className="row">
                      <section className="property1">
                        <div className="container">
                          <div className="row">
                            <div className="col-6">
                              <h2 className="color-maroon fw-bold">
                                {bsHouseSpecList?.property_name}
                              </h2>
                              <p>
                                <span className="material-symbols-rounded filled-icon close-icon">
                                  location_on
                                </span>
                                {bsHouseSpecList?.property_information?.address}
                              </p>
                            </div>
                            <div className="col-6 text-end">
                              <div className="row">
                                <div className="col-6">
                                  <h2 className="color-maroon fw-bold">
                                    ₹&nbsp;
                                    {bsHouseSpecList?.property_information
                                      ?.price
                                      ? bsHouseSpecList?.property_information
                                          ?.price
                                      : "N/A"}
                                  </h2>
                                </div>
                                <div className="col-6">
                                  {!state?.auth?.isLoggedIn ? (
                                    <button
                                      type="button"
                                      className="btn mx-2  login-btn"
                                      onClick={() => {
                                        setForm(true);
                                      }}
                                    >
                                      Show Interest
                                    </button>
                                  ) : (
                                    <button
                                      type="button"
                                      className="btn mx-2  login-btn"
                                      onClick={(e) => {
                                        handleSubmitBsHouseSpec(e);
                                      }}
                                    >
                                      Show Interest
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-lg-11 mx-auto ms-auto">
                              <div className="row">
                                <div className="col-lg-6">
                                  <img
                                    className="w-100 m-auto"
                                    style={{ borderRadius: "8px" }}
                                    src={bsHouseSpecList?.cover_image}
                                    alt=""
                                  />
                                </div>
                                <div className="col-lg-6">
                                  <div className="row">
                                    {bsHouseSpecList &&
                                      bsHouseSpecList?.property_image?.map(
                                        (image, index) => {
                                          return (
                                            <div
                                              className="col-lg-6"
                                              key={index}
                                            >
                                              <img
                                                style={{
                                                  width: "250px",
                                                  height: "250px",
                                                  borderRadius: "8px",
                                                }}
                                                src={image}
                                                alt=""
                                              />
                                            </div>
                                          );
                                        }
                                      )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      <section className="propertydetail">
                        <div className="container">
                          <div className="row">
                            <div className="col-lg-12 mx-auto ms-auto">
                              <div className="row">
                                <div className="col-lg-12">
                                  <div className="propertydetailcard">
                                    <div className="row">
                                      <div className="col-lg-3">
                                        <div className="row">
                                          <div className="col-lg-12">
                                            <div className="propertydetailpoint">
                                              {bsHouseSpecList?.property_type}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-4 col-12">
                                        <div className="propertydetailpoint">
                                          <div className="row">
                                            <div className="col-lg-8 col-6">
                                              Room Size :
                                            </div>
                                            <div className="col-lg-4 col-6">
                                              {
                                                bsHouseSpecList
                                                  ?.property_information
                                                  ?.room_size
                                              }
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-5 col-12">
                                        <div className="propertydetailpoint">
                                          <div className="row">
                                            <div className="col-lg-5 col-6">
                                              Sq Ft :
                                            </div>
                                            <div className="col-lg-7 col-6">
                                              {
                                                bsHouseSpecList
                                                  ?.property_information?.sq_ft
                                              }
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <h6 className="propertydes">Description</h6>
                                    <p
                                      className="smallpara"
                                      dangerouslySetInnerHTML={
                                        {
                                          __html: decode(
                                            bsHouseSpecList?.property_desc
                                          ),
                                        }
                                          ? {
                                              __html: decode(
                                                bsHouseSpecList?.property_desc
                                              ),
                                            }
                                          : "N/A"
                                      }
                                    ></p>

                                    <div className="blogcardbottom"></div>
                                    <h6 className="propertydes">
                                      Property Details
                                    </h6>
                                    {bsHouseSpecList?.property_type ===
                                    "Plot" ? (
                                      <>
                                        <div className="row">
                                          <div className="col-lg-4">
                                            <p className="propertydescardpara">
                                              Room Size :
                                              <span className="propertydescardparabold">
                                                {bsHouseSpecList
                                                  ?.property_information
                                                  ?.room_size
                                                  ? bsHouseSpecList
                                                      ?.property_information
                                                      ?.room_size
                                                  : "N/A"}
                                              </span>
                                            </p>
                                          </div>
                                          <div className="col-lg-4">
                                            <p className="propertydescardpara">
                                              Property Type :
                                              <span className="propertydescardparabold">
                                                {bsHouseSpecList?.property_type
                                                  ? bsHouseSpecList?.property_type
                                                  : "N/A"}
                                              </span>
                                            </p>
                                          </div>
                                          <div className="col-lg-4">
                                            <p className="propertydescardpara">
                                              Facing :
                                              <span className="propertydescardparabold">
                                                {bsHouseSpecList
                                                  ?.property_information
                                                  ?.view_facing
                                                  ? bsHouseSpecList
                                                      ?.property_information
                                                      ?.view_facing
                                                  : "N/A"}
                                              </span>
                                            </p>
                                          </div>
                                        </div>
                                        <div className="row">
                                          <div className="col-lg-4">
                                            <p className="propertydescardpara">
                                              Price Per Sq.ft :
                                              <span className="propertydescardparabold">
                                                {bsHouseSpecList?.Price_per_sqft
                                                  ? bsHouseSpecList?.Price_per_sqft
                                                  : "N/A"}
                                              </span>
                                            </p>
                                          </div>
                                          <div className="col-lg-4">
                                            <p className="propertydescardpara">
                                              Road Size :
                                              <span className="propertydescardparabold">
                                                {bsHouseSpecList?.Road_Size
                                                  ? bsHouseSpecList?.Road_Size
                                                  : "N/A"}
                                              </span>
                                            </p>
                                          </div>
                                          <div className="col-lg-4"></div>
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        <div className="row">
                                          <div className="col-lg-3">
                                            <p className="propertydescardpara">
                                              Property ID :
                                              <span className="propertydescardparabold">
                                                {bsHouseSpecList?.propertyid
                                                  ? bsHouseSpecList?.propertyid
                                                  : "N/A"}
                                              </span>
                                            </p>
                                          </div>
                                          <div className="col-lg-4">
                                            <p className="propertydescardpara">
                                              Year Built :
                                              <span className="propertydescardparabold">
                                                {bsHouseSpecList
                                                  ?.property_information
                                                  ?.year_build
                                                  ? bsHouseSpecList
                                                      ?.property_information
                                                      ?.year_build
                                                  : "N/A"}
                                              </span>
                                            </p>
                                          </div>
                                          <div className="col-lg-5">
                                            <p className="propertydescardpara">
                                              Price :
                                              <span className="propertydescardparabold">
                                                ₹&nbsp;
                                                {bsHouseSpecList
                                                  ?.property_information?.price
                                                  ? bsHouseSpecList
                                                      ?.property_information
                                                      ?.price
                                                  : "N/A"}
                                              </span>
                                            </p>
                                          </div>
                                        </div>
                                        <div className="row">
                                          <div className="col-lg-3">
                                            <p className="propertydescardpara">
                                              Room Size :
                                              <span className="propertydescardparabold">
                                                {bsHouseSpecList
                                                  ?.property_information
                                                  ?.room_size
                                                  ? bsHouseSpecList
                                                      ?.property_information
                                                      ?.room_size
                                                  : "N/A"}
                                              </span>
                                            </p>
                                          </div>
                                          <div className="col-lg-4">
                                            <p className="propertydescardpara">
                                              Property Type :
                                              <span className="propertydescardparabold">
                                                {bsHouseSpecList?.property_type
                                                  ? bsHouseSpecList?.property_type
                                                  : "N/A"}
                                              </span>
                                            </p>
                                          </div>
                                          <div className="col-lg-5">
                                            <p className="propertydescardpara">
                                              Property Size :
                                              <span className="propertydescardparabold">
                                                {bsHouseSpecList
                                                  ?.property_information?.sq_ft
                                                  ? bsHouseSpecList
                                                      ?.property_information
                                                      ?.sq_ft
                                                  : "N/A"}
                                              </span>
                                            </p>
                                          </div>
                                        </div>
                                        <div className="row">
                                          <div className="col-lg-3">
                                            <p className="propertydescardpara">
                                              Parking :
                                              <span className="propertydescardparabold">
                                                {bsHouseSpecList?.parking
                                                  ? bsHouseSpecList?.parking
                                                  : "N/A"}
                                              </span>
                                            </p>
                                          </div>
                                          <div className="col-lg-4">
                                            <p className="propertydescardpara">
                                              Furnished :
                                              <span className="propertydescardparabold">
                                                {bsHouseSpecList?.furnished_type
                                                  ? bsHouseSpecList?.furnished_type
                                                  : "N/A"}
                                              </span>
                                            </p>
                                          </div>
                                          <div className="col-lg-5">
                                            <p className="propertydescardpara">
                                              Facing :
                                              <span className="propertydescardparabold">
                                                {bsHouseSpecList
                                                  ?.property_information
                                                  ?.view_facing
                                                  ? bsHouseSpecList
                                                      ?.property_information
                                                      ?.view_facing
                                                  : "N/A"}
                                              </span>
                                            </p>
                                          </div>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                                <div className="propertydetailcard my-4">
                                  <h6 className="propertydes">Floor Plans</h6>
                                  <div
                                    className="accordion"
                                    id="accordionPanelsStayOpenExample"
                                  >
                                    {bsHouseSpecList &&
                                      bsHouseSpecList?.floor_information?.map(
                                        (floor, index) => {
                                          return (
                                            <div
                                              className="accordion-item"
                                              key={index}
                                            >
                                              <h2
                                                className="accordion-header"
                                                id="panelsStayOpen-headingOne"
                                              >
                                                <button
                                                  className="accordion-button"
                                                  type="button"
                                                  data-bs-toggle="collapse"
                                                  data-bs-target={`#panelsStayOpen-collapseOne${index}`}
                                                  aria-expanded="true"
                                                  aria-controls="panelsStayOpen-collapseOne"
                                                >
                                                  Floor No : {floor.floor_no}
                                                </button>
                                              </h2>
                                              <div
                                                id={`panelsStayOpen-collapseOne${index}`}
                                                className="accordion-collapse collapse show"
                                                aria-labelledby="panelsStayOpen-headingOne"
                                              >
                                                <div className="accordion-body">
                                                  <img
                                                    className="floorimage"
                                                    style={{width:"auto",
                                                    height:"400px"}}
                                                    src={
                                                      floor?.floor_image
                                                        ? floor?.floor_image
                                                        : "N/A"
                                                    }
                                                    alt=""
                                                  />
                                                  <p className="accpara">
                                                    {floor.floor_desc}
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                          );
                                        }
                                      )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div className="client-left-section py-5">
        <div className="container my-4">
          <h1 className="banner-heading after-line mb-5">FEEL FREE TO ASK</h1>
          <div className="row">
            <div className="col-lg-6" data-aos="fade-left">
              <div>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.823571029211!2d80.23700327559305!3d13.046899587275508!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5267c25ec3b519%3A0xb10841584ccc73c4!2sDALMAF%20Private%20Limited!5e0!3m2!1sen!2sin!4v1688118977225!5m2!1sen!2sin"
                  width="100%"
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
            <div className="col-lg-6 col-md-12" data-aos="fade-left">
             
              <div className="row">
                <div className="col-lg-6 col-md-6">
                  <div className="mb-4">
                    <label className="form-label">
                      Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Your Name"
                      aria-invalid={Boolean(
                        bsHouseSpecValidation?.name?.status === false
                      )}
                      value={bsHouseSpec?.name || ""}
                      onChange={(e) => {
                        setBsHouseSpecValue("name", e.target.value);
                      }}
                      onBlur={(e) => {
                        setBsHouseSpecValidationValue(
                          "name",
                          StringValidation(e.target.value)
                        );
                      }}
                    />
                    <small className="text-danger">
                      {bsHouseSpecValidation?.name?.message
                        ? `Name ${bsHouseSpecValidation?.name?.message}`
                        : ""}
                    </small>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="mb-4">
                    <label className="form-label">
                      Mobile No <span className="text-danger">*</span>
                    </label>
                    <input
                      type="tel"
                      maxLength={10}
                      className="form-control"
                      placeholder="Enter Your Mobile No"
                      aria-invalid={Boolean(
                        bsHouseSpecValidation?.mobileNumber?.status === false
                      )}
                      value={bsHouseSpec?.mobileNumber || ""}
                      onChange={(e) => {
                        setBsHouseSpecValue("mobileNumber", e.target.value);
                      }}
                      onBlur={(e) => {
                        setBsHouseSpecValidationValue(
                          "mobileNumber",
                          PhoneNumberValidation(e.target.value)
                        );
                      }}
                    />
                    <small className="text-danger">
                      {bsHouseSpecValidation?.mobileNumber?.message
                        ? `Mobile no ${bsHouseSpecValidation?.mobileNumber?.message}`
                        : ""}
                    </small>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="mb-4">
                    <label className="form-label">
                      E- Mail ID <span className="text-danger">*</span>
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Enter Your E- Mail ID"
                      aria-invalid={Boolean(
                        bsHouseSpecValidation?.emailId?.status === false
                      )}
                      value={bsHouseSpec?.emailId?.toLowerCase() || ""}
                      onChange={(e) => {
                        setBsHouseSpecValue("emailId", e.target.value);
                      }}
                      onBlur={(e) => {
                        setBsHouseSpecValidationValue(
                          "emailId",
                          EmailValidation(e.target.value)
                        );
                      }}
                    />
                    <small className="text-danger">
                      {bsHouseSpecValidation?.emailId?.message
                        ? `Email ${bsHouseSpecValidation?.emailId?.message}`
                        : ""}
                    </small>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="mb-4">
                    <label className="form-label">
                      Questions <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Your Questions "
                      aria-invalid={Boolean(
                        bsHouseSpecValidation?.question?.status === false
                      )}
                      value={bsHouseSpec?.question || ""}
                      onChange={(e) => {
                        setBsHouseSpecValue("question", e.target.value);
                      }}
                      onBlur={(e) => {
                        setBsHouseSpecValidationValue(
                          "question",
                          NonEmptyValidation(e.target.value)
                        );
                      }}
                    />
                    <small className="text-danger">
                      {bsHouseSpecValidation?.question?.message
                        ? `Question ${bsHouseSpecValidation?.question?.message}`
                        : ""}
                    </small>
                  </div>
                  <div className="col-lg-12">
                    <div className="mb-4">
                      <label className="form-label">
                        Service Type

                      </label>
                      <select
                        className="form-control form-control-lg"
                        value={bsHouseSpec?.servicesType || ""}
                        onChange={(e) => {
                          setBsHouseSpecValue("servicesType", e.target.value);
                        }}
                        onBlur={(e) => {
                          setBsHouseSpecValidationValue(
                            "servicesType",
                            NonEmptyValidation(e.target.value)
                          );
                        }}
                      >
                        <option value="">---Select Service Type---</option>
                        <option value="Legal">Legal</option>
                        <option value="Audit">Audit</option>
                        <option value="Manpower">Manpower</option>
                        <option value="Auction">Auction</option>
                        <option value="Buy/Sell">Buy/Sell</option>
                      </select>
                     
                    </div>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="mb-4">
                    <label className="form-label">
                      Subject <span className="text-danger">*</span>
                    </label>
                    <textarea
                      rows="6"
                      className="form-control"
                      placeholder="Enter Subject"
                      aria-invalid={Boolean(
                        bsHouseSpecValidation?.subject?.status === false
                      )}
                      value={bsHouseSpec?.subject || ""}
                      onChange={(e) => {
                        setBsHouseSpecValue("subject", e.target.value);
                      }}
                      onBlur={(e) => {
                        setBsHouseSpecValidationValue(
                          "subject",
                          NonEmptyValidation(e.target.value)
                        );
                      }}
                    ></textarea>
                    <small className="text-danger">
                      {bsHouseSpecValidation?.subject?.message
                        ? `Subject ${bsHouseSpecValidation?.subject?.message}`
                        : ""}
                    </small>
                  </div>
                </div>
                <div className="col-lg-12">
                  

                  <button
                    type="button"
                    className="btn login-btn w-100"
                    onClick={(e) => {
                      handleSubmit(e);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
              {/* )} */}
            </div>
          </div>
        </div>
      </div>
      <div className="number-counter py-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6" data-aos="fade-in">
              <div className="counter-content text-start">
                <div className="d-flex align-items-center">
                  <div className="me-3">
                    <h1 className="mb-0">
                      <span className="material-symbols-rounded align-middle about-call filled-icon">
                        call
                      </span>
                    </h1>
                  </div>
                  <div className="">
                    <h5 className="fs-6 mb-0">Toll Free</h5>
                    <h5 className="mb-0 fs-4">1800-309-8445</h5>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6" data-aos="fade-in">
              <div className="counter-content text-start">
                <div className="d-flex align-items-center">
                  <div className="me-3">
                    <h1 className="mb-0">
                      <span className="material-symbols-rounded align-middle about-call filled-icon">
                        mail
                      </span>
                    </h1>
                  </div>
                  <div className="">
                    <h5 className="fs-6 mb-0">Email ID</h5>
                    <h5 className="mb-0 fs-4">info@dalmaf.com</h5>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6" data-aos="fade-in">
              <div className="counter-content text-start">
                <div className="d-flex align-items-center">
                  <div className="me-3">
                    <h1 className="mb-0">
                      <i className="fa-brands fa-whatsapp about-whatsapp-icon"></i>
                    </h1>
                  </div>
                  <div className="">
                    <h5 className="fs-6 mb-0">WhatsApp Us</h5>
                    <h5 className="mb-0 fs-4">+91 96000 38059</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <ServicesAllpages />
      </div>
      <CustomModal
        open={form}
        onClickOutside={() => {
          setForm(false);
        }}
      >
        <div className="modal-content w-50 m-auto">
          <div className="modal-body p-0 ">
            <div className="container ">
              <span
                className="material-symbols-rounded filled-icon close-icon"
                style={{
                  marginRight: "30px",
                  marginTop: "50px",
                  textShadow: "rgb(171 167 167 / 44%) 0px 3px 6px",
                }}
                onClick={() => {
                  setForm(false);
                }}
              >
                close
              </span>
              <div className="row d-flex align-items-center justify-content-center  mt-0">
                <div className="container ">
                  <div className="row justify-content-center">
                    <div className="col-lg-12">
                      <div className=" my-5 px-3">
                        <div className="row justify-content-center mt-2">
                          <div className="mb-2">
                            <b>
                              Please enter your information below, <br />
                              Our staff will contact you as soon as possible.
                            </b>
                          </div>
                          <hr />
                          <div className="col-lg-6 col-md-6">
                            <div className="mb-4">
                              <label className="form-label">
                                Name <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Your Name"
                                aria-invalid={Boolean(
                                  bsHouseSpecValidation1?.name?.status === false
                                )}
                                defaultValue={bsHouseSpec1?.name}
                                onChange={(e) => {
                                  setBsHouseSpecValue1("name", e.target.value);
                                }}
                                onBlur={(e) => {
                                  setBsHouseSpecValidationValue1(
                                    "name",
                                    StringValidation(e.target.value)
                                  );
                                }}
                              />
                              <small className="text-danger">
                                {bsHouseSpecValidation1?.name?.message
                                  ? `Name ${bsHouseSpecValidation1?.name?.message}`
                                  : ""}
                              </small>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6">
                            <div className="mb-4">
                              <label className="form-label">
                                Mobile No <span className="text-danger">*</span>
                              </label>
                              <input
                                type="tel"
                                maxLength={10}
                                className="form-control"
                                defaultValue={bsHouseSpec1?.mobileNumber}
                                placeholder="Enter Your Mobile No"
                                aria-invalid={Boolean(
                                  bsHouseSpecValidation1?.mobileNumber
                                    ?.status === false
                                )}
                                onChange={(e) => {
                                  setBsHouseSpecValue1(
                                    "mobileNumber",
                                    e.target.value
                                  );
                                }}
                                onBlur={(e) => {
                                  setBsHouseSpecValidationValue1(
                                    "mobileNumber",
                                    PhoneNumberValidation(e.target.value)
                                  );
                                }}
                              />
                              <small className="text-danger">
                                {bsHouseSpecValidation1?.mobileNumber?.message
                                  ? `Mobile no ${bsHouseSpecValidation1?.mobileNumber?.message}`
                                  : ""}
                              </small>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6">
                            <div className="mb-4">
                              <label className="form-label">
                                E- Mail ID{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="email"
                                className="form-control"
                                placeholder="Enter Your E- Mail ID"
                                aria-invalid={Boolean(
                                  bsHouseSpecValidation1?.email?.status ===
                                    false
                                )}
                                defaultValue={
                                  bsHouseSpec1?.email?.toLowerCase() || ""
                                }
                                onChange={(e) => {
                                  setBsHouseSpecValue1(
                                    "email",
                                    e.target.value?.toLowerCase()
                                  );
                                }}
                                onBlur={(e) => {
                                  setBsHouseSpecValidationValue1(
                                    "emailId",
                                    EmailValidation(
                                      e.target.value
                                    )?.toLowerCase()
                                  );
                                }}
                              />
                              <small className="text-danger">
                                {bsHouseSpecValidation1?.email?.message
                                  ? `Email ${bsHouseSpecValidation1?.email?.message}`
                                  : ""}
                              </small>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6">
                            <div className="mb-4">
                              <label className="form-label">Questions</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Your Questions "
                                aria-invalid={Boolean(
                                  bsHouseSpecValidation1?.question?.status ===
                                    false
                                )}
                                onChange={(e) => {
                                  setBsHouseSpecValue1(
                                    "question",
                                    e.target.value
                                  );
                                }}
                              />
                            </div>
                          </div>

                          <div className="col-lg-12">
                            <div className="mb-4">
                              <label className="form-label">
                                Service Type{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <select
                                className="form-control form-control-lg"
                                value={bsHouseSpec1?.servicesType}
                                onChange={(e) => {
                                  setBsHouseSpecValue1(
                                    "servicesType",
                                    e.target.value
                                  );
                                }}
                                onBlur={(e) => {
                                  setBsHouseSpecValidationValue1(
                                    "servicesType",
                                    NonEmptyValidation(e.target.value)
                                  );
                                }}
                              >
                                <option value="">
                                  ---Select Service Type---
                                </option>
                                <option value="Legal">Legal</option>
                                <option value="Audit">Audit</option>
                                <option value="Manpower">Manpower</option>
                                <option value="Auction">Auction</option>
                                <option value="Buy/Sell">Buy/Sell</option>
                              </select>
                              <small className="text-danger">
                                {bsHouseSpecValidation1?.servicesType?.message
                                  ? `Service Type ${bsHouseSpecValidation1?.servicesType?.message}`
                                  : ""}
                              </small>
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="mb-4">
                              <label className="form-label">Subject</label>
                              <textarea
                                rows="6"
                                className="form-control"
                                placeholder="Enter Subject"
                                aria-invalid={Boolean(
                                  bsHouseSpecValidation1?.subject?.status ===
                                    false
                                )}
                                onChange={(e) => {
                                  setBsHouseSpecValue1(
                                    "subject",
                                    e.target.value
                                  );
                                }}
                              ></textarea>
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <button
                              type="button"
                              className="btn login-btn w-100"
                              onClick={(e) => {
                                handleSubmitServiceform(e);
                              }}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CustomModal>
    </div>
  );
}
